import { KEYS} from '../../../../l18n/constants';
import { useParams } from 'react-router-dom';
import { useL18nContext } from '../../ContextProvider/L18n';
import usePartnerDetails from '../../../../hooks/data/usePartnerDetails';
import ProcessingOverlay from '../../ProcessingOverlay';
import PartnerAddressContactDetailsMap from './AddressContactDetailsMap';
import PartnerProfileNavigationAndToolbar from './NavigationAndToolbar';
import PartnerLogoRolesAndLevels from './LogoRolesAndLevels';
import PartnerExpertisesAndOverview from './ExpertisesAndOverview';

export default function PagePartnerProfile() {
  const { partnerId } = useParams();

  const {
    isPartnerDetailsFetchingInProgress,
    hasPartnerDetailsFetchingError,
    partnerDetails
  } = usePartnerDetails(partnerId);

  const { getTranslationFor } = useL18nContext();

  const partnerBeGeoId = partnerDetails?.be_geo_id||0;
  const partnerRolesAndLevels = partnerDetails?.rolesAndLevels||{};
  const partnerRoles = Object.keys(partnerRolesAndLevels);
  const partnerName = partnerDetails?.partner_name||'';
  const partnerDescription = partnerDetails?.note_text|| getTranslationFor(KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT, 'No description provided.', );
  const partnerExpertises = partnerDetails?.qualifications || [];
  const partnerTechnologies = (partnerDetails?.technology_keywords || '').split(',');
  const partnerIndustries = (partnerDetails?.industry_keywords || '').split(',');
  const isDiversePartner = partnerDetails?.isDiversePartner || false;
  const partnerDiversityProgramNames = partnerDetails?.partnerDiversityProgramNames || [];

  return (
    <div className="relative w-full text-cc-body-medium sm:text-cc-body-large bg-cc-primary text-cc-primary-contrast">
      {
        !isPartnerDetailsFetchingInProgress && !hasPartnerDetailsFetchingError && !!partnerDetails &&
        <>
          <PartnerProfileNavigationAndToolbar className="mb-20 pt-16" partnerDetails={partnerDetails}/>

          <PartnerLogoRolesAndLevels className="mb-8"
                                     partnerBeGeoId={partnerBeGeoId}
                                     partnerRolesAndLevels={partnerRolesAndLevels}/>

          <PartnerAddressContactDetailsMap className="mb-20 px-5 xs:px-0 xs:mx-auto xs:w-8/12"
                                           partnerDetails={partnerDetails}/>

          <PartnerExpertisesAndOverview className=""
                                        partnerName={partnerName}
                                        partnerDescription={partnerDescription}
                                        partnerRolesAndLevels={partnerRolesAndLevels}
                                        partnerExpertises={partnerExpertises}
                                        partnerRoles={partnerRoles}
                                        partnerTechnologies={partnerTechnologies}
                                        partnerIndustries={partnerIndustries}
                                        isDiversePartner={isDiversePartner}
                                        partnerDiversityProgramNames={partnerDiversityProgramNames}/>
        </>
      }
      <ProcessingOverlay isVisible={isPartnerDetailsFetchingInProgress}/>
    </div>
  );
}
